/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { getRequest, delRequest } from "../../axiosRoutes/index";
import {
  Button,
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Pagination,
  Tooltip,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import AddProject from "./AddProject";
import SideNavBar from "../sidebar/SideNav";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import CloseIcon from "@mui/icons-material/Close";
import AssignProject from "./AssignProject";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import { useInView } from 'react-intersection-observer';

const Projects = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const [hover, setHover] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [projectStatus, setProjectStatus] = useState([]);
  const [projects, setProjects] = useState([]);
  const [unassignData, setUnassignData] = useState({
    userId: "",
  });
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openProject, setOpenProject] = useState(false);
  const [proId, setProId] = useState(null);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [openAssign, setOpenAssign] = useState(false);
  const [assignData, setAssignData] = useState([]);
  const [openUnassign, setOpenUnassign] = useState(false);
  const [projectData, setProjectData] = useState({
    title: "",
    clientName: "",
    manager: "",
    description: "",
    startDate: "",
    deadLine: "",
    status: "",
  });
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [isFetchingProjects, setIsFetchingProjects] = useState(false)
  const { ref, inView } = useInView({
          threshold: 0,
      });
  const [limit, setLimit] = useState(10)
  
  useEffect(() => {
    if (inView) {
      if(limit < totalPages * 10){
        setLimit(prev=>prev+10)
      }
    }
  }, [inView]);

  const fetchStatus = async () => {
    try {
      const response = await getRequest("filter/project");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setProjectStatus(statusArray);
    } catch (error) {
      console.error("Error fetching Filter:", error);
    }
  };

  const fetchProjects = async () => {
    const access = localStorage.getItem("access");
    try {
      !isSmallScreen && setLoading(true)
      setIsFetchingProjects(true)
      const response = await getRequest("project", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        params: !isSmallScreen ? {page:page} : {limit: limit}
      });
      setIsFetchingProjects(false)
      setTotalPages(response?.totals?.total_pages)
      const result = response?.data
      const formattedProjects = result.map((project) => {
        if (project.startDate) {
          const startDate = new Date(project.startDate);
          const deadLine = new Date(project.deadLine);
          project.startDate = startDate.toLocaleDateString("en-GB");
          project.deadLine = deadLine.toLocaleDateString("en-GB");
        }
        const statusObj = projectStatus.find(
          (status) => status.value === project.status
        );
        project.status = statusObj ? statusObj.label : project.status;
        return project;
      });
      setProjects(formattedProjects)
    } catch (error) {
      console.error("Error Fetching Projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchStatus();
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (projectStatus.length > 0) {
      fetchProjects();
    }
  }, [projectStatus, page, limit]);

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(`project/${deleteId}`, access);
      fetchProjects();
      handleClose();
      showSnackbar(response, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleAssignOpen = () => {
    setOpenAssign(true);
  };

  const handleAssign = (id) => {
    setProId(id);
    handleAssignOpen();
  };

  const handleUnassignOpen = (id) => {
    setProId(id);
    setOpenUnassign(true);
  };

  const handleProject = (id) => {
    setOpenProject(true);
    setProId(id);
  };

  useEffect(() => {
    if (proId !== null) {
      const fetchProject = async () => {
        const access = localStorage.getItem("access");
        try {
          const res = await getRequest(`project/${proId}`, {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          });
          const assignedData = res.assignedTo.map((user) => ({
            userId: user.userId,
            name: user.name,
          }));
          setAssignData(assignedData);
          const formatStart = new Date(res.startDate)
            .toISOString()
            .split("T")[0];
          const formatDead = new Date(res.deadLine).toISOString().split("T")[0];
          let returnStatus = () => {
            return projectStatus.find(
                        (status) => status.value === res.status
                    )?.label
          }
          setProjectData((prevData) => ({
            ...prevData,
            title: res.title || "N/A",
            clientName: res.clientName || "N/A",
            manager: res.manager || "N/A",
            description: res.description || "N/A",
            startDate: formatStart || "N/A",
            deadLine: formatDead || "N/A",
            status: returnStatus()
          }));
        } catch (error) {
          console.error("Error fetching Project:", error);
        }
      };
      fetchProject();
    }
  }, [proId]);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const selectProject = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  const handleSelectChange = (event) => {
    const selectedUserId = event.target.value;
    setUnassignData((prevState) => ({
      ...prevState,
      userId: selectedUserId,
    }));
  };

  const handleUnassign = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(
        `project/${proId}/assignTo`,
        access,
        unassignData
      );
      fetchProjects();
      handleClose();
      showSnackbar(response, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setOpenProject(false);
    setOpenAssign(false);
    setProId(null);
    setOpen(false);
    setOpenUnassign(false);
    setAssignData([]);
    fetchProjects();
    setDeleteId(null);
    setUpdateId(null);
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: '#1F1F1F'
  }

  const dataTableCellStyle = (hover, id) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: '10px 16px',
      backgroundColor: '#292929'
    }
  }

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        <SideNavBar />
        <div style={{ flex: 1, margin: `${isSmallScreen ? '3.2rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
          <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
                padding: "1rem",
              }}
            >
              <Grid item>
                <h1>Projects</h1>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleOpen}
                  sx={{
                    backgroundColor: "#fff",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#e1e1e1",
                    },
                  }}
                >
                  Add Project
                </Button>
              </Grid>
            </Grid>
            {projects.length === 0 ? (
              <Typography variant="h6" sx={{ color: "#fff", textAlign: "center" }}>
                No Data Yet
              </Typography>
            ) : (
              <>
                {!isSmallScreen ? (
                  <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                    <Table
                      style={{
                        borderRadius: "25px",
                        borderCollapse: "separate",
                        overflow: "hidden",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell style={headingTableCellStyle}>
                            ID
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Title
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Client Name
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Manager
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Start Date
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Deadline
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Assigned To
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Status
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {projects.map((project, id) => (
                          <TableRow
                            key={id}
                            style={{
                              cursor: "pointer",
                              height: "60px",
                            }}
                            onMouseEnter={() => setHover(id)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleProject(project._id)}
                          >
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {(page - 1) * 10 + id + 1}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.title}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.clientName}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.manager || "N/A"}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.startDate}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.deadLine}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.assignedTo &&
                              project.assignedTo.length > 0
                                ? project.assignedTo.map((assign, keys) => (
                                  <li key={keys}>{assign.name}</li>
                                ))
                                : "N/A"}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              {project.status}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(hover, id)}>
                              <Tooltip title="Assign" placement="top">
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#1976D2",
                                    marginRight: "5px",
                                  }}
                                  aria-label="edit"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAssign(project._id)
                                  }}
                                >
                                  <InventoryOutlinedIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="UnAssign" placement="top">
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#F44336",
                                    marginRight: "5px",
                                  }}
                                  aria-label="edit"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUnassignOpen(project._id)
                                  }}
                                >
                                  <DeleteSweepIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleProject(project._id)
                                }}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectProject(project._id)
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "5px",
                                }}
                                aria-label="delete"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(project._id)
                                }}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#1F1F1F" }}>
                        <TableRow>
                          <TableCell
                            colSpan={100}
                            style={{
                              color: "white",
                              border: "none",
                              textAlign: "center",
                            }}
                          >
                            <Pagination
                              count={totalPages}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={(e, value) => {
                                setPage(value);
                              }}
                              sx={{
                                display: "inline-block",
                                "& .MuiPaginationItem-root": {
                                  color: "#fff",
                                  borderColor: "#fff",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid container spacing={1} justifyContent='center'>
                    {projects.map((project, id) => (
                      <Grid item xs={12} key={id}>
                        <Card ref = {id+1 ===projects.length ? ref : null}
                          sx={{
                            backgroundColor: "#101010",
                            color: "#fff",
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => handleProject(project._id)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <CardContent sx={{padding: '16px 2px 16px 15px', width: '50%', wordWrap: 'break-word'}}>
                              <Typography variant="h6">
                                {project.title}
                              </Typography>
                              <Typography variant="body2">
                                {project.clientName}
                                <br />
                                {project.status}
                              </Typography>
                            </CardContent>
                            <CardActions sx={{ width: '50%', justifyContent: 'left', flexWrap: 'wrap', paddingRight: '0px'}}>
                              <Tooltip title="Assign" placement="top">
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#1976D2",
                                    margin: '4px 5px 5px 0px'
                                  }}
                                  aria-label="edit"
                                  size="medium"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAssign(project._id)
                                  }}
                                >
                                  <InventoryOutlinedIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="UnAssign" placement="top">
                                <IconButton
                                  style={{
                                    color: "#fff",
                                    backgroundColor: "#F44336",
                                    margin: '4px 5px 5px 0px'
                                  }}
                                  aria-label="edit"
                                  size="medium"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUnassignOpen(project._id)
                                  }}
                                >
                                  <DeleteSweepIcon fontSize="inherit" />
                                </IconButton>
                              </Tooltip>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  margin: '4px 5px 5px 0px'
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleProject(project._id)
                                }}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  margin: '4px 5px 5px 0px'
                                }}
                                aria-label="edit"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectProject(project._id)
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  margin: '4px 5px 5px 0px'
                                }}
                                aria-label="delete"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(project._id)
                                }}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </CardActions>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            )}
          </Box>
          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are You Sure You Want to Delete this Project?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openProject}
            maxWidth
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                opacity: 0.9,
                color: "#fff",
                padding: "5px",
                maxWidth: { xs: "90%", md: "45%" },
                border: "2px solid #D0521B",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              {projectData.title}
              <IconButton
                onClick={handleClose}
                sx={{
                  color: "#fff",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid container justifyContent="space-between" alignItems="center" sx={{ borderTop: "2px solid #D0521B", paddingTop: "1rem", }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Title:</b> {projectData.title}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Client Name:</b> {projectData.clientName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Description:</b> {projectData.description}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Manager:</b> {projectData.manager}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Start Date:</b> {projectData.startDate}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Dead Line:</b> {projectData.deadLine}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Status:</b> {projectData.status}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog
            maxWidth="sm"
            open={openUnassign}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "20px",
                borderRadius: "8px",
              },
              "& .MuiDialogTitle-root": {
                padding: "10px 5px",
                borderBottom: "1px solid #E5622D",
              },
              "& .MuiDialogContent-root": {
                padding: "10px",
              },
              "& .MuiDialogActions-root": {
                padding: "10px 5px",
                justifyContent: "space-around",
              },
            }}
          >
            <DialogTitle
              sx={{
                typography: "h6",
                marginBottom: "10px",
                fontWeight: "bold",
                color: "#E5622D",
              }}
            >
              Confirm UnAssign Project
            </DialogTitle>
            <DialogContent>
              <DialogContentText sx={{ marginBottom: "20px", color: "#fff" }}>
                Are you sure you want to unassign this Project to selected
                employee?
              </DialogContentText>
              {assignData.length === 0 ? (
                <Typography
                  variant="h6"
                  sx={{ color: "#fff", textAlign: "center", margin: "10px 0" }}
                >
                  No Item Assigned Yet
                </Typography>
              ) : (
                <FormControl
                  variant="outlined"
                  fullWidth
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      color: "#FEFEFE",
                      "& fieldset": {
                        borderColor: "#FEFEFE",
                      },
                      "&:hover fieldset": {
                        borderColor: "#FEFEFE",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#FEFEFE",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "#FEFEFE",
                    },
                  }}
                >
                  <InputLabel id="client-select-label">Employee Name</InputLabel>
                  <Select
                    labelId="client-select-label"
                    value={unassignData.userId}
                    onChange={handleSelectChange}
                    label="Employee Name"
                  >
                    {assignData.map((assign) => (
                      <MenuItem key={assign.userId} value={assign.userId}>
                        {assign.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={assignData.length === 0}
                onClick={handleUnassign}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                  "&.Mui-disabled": {
                    backgroundColor: "#EC916C",
                    color: "#fff",
                  },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>

          <AddProject
            open={openModal}
            handleClose={handleClose}
            projectId={updateId}
          />
          <AssignProject
            open={openAssign}
            handleClose={handleClose}
            proId={proId}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{position: 'fixed', bottom: (isFetchingProjects ? '20px' : '-100px'), transition: 'bottom 0.5s ease'}}>
              <CircularProgress size="3rem" sx={{color: "#FF5722"}} />
            </Grid>}
    </>
  );
};

export default Projects;
